<template>
  <span
    class="navrh-control-tip"
    :class="{'navrh-control-tip--block': block, 'navrh-control-tip--icon-only': iconOnly}"
  >
    <v-tooltip
      v-if="!iconOnly"
      top
      open-on-click
    >
      <template #activator="{ on, attrs }">
        <span
          class="navrh-control-tip__wrap"
          tabindex="0"
          v-bind="attrs"
          v-on="on"
        >
          <slot />
        </span>
      </template>
      <span>{{ resolvedText }}</span>
    </v-tooltip>
    <slot v-if="iconOnly" />
    <v-tooltip
      top
      open-on-click
    >
      <template #activator="{ on, attrs }">
        <v-icon
          x-small
          class="navrh-control-tip__icon"
          tabindex="0"
          role="button"
          aria-label="Nápověda"
          v-bind="attrs"
          v-on="on"
        >
          info_outline
        </v-icon>
      </template>
      <span>{{ resolvedText }}</span>
    </v-tooltip>
  </span>
</template>

<script lang="ts">
    import Vue from 'vue';
    import {resolveControlTipText} from '@/utils/controlTipText';

    export default Vue.extend({
        name: 'NavrhControlTip',
        props: {
            text: {type: String, required: true},
            block: {type: Boolean, default: false},
            iconOnly: {type: Boolean, default: false},
        },
        computed: {
            resolvedText(): string {
                return resolveControlTipText(this.text, 'NavrhControlTip');
            },
        },
    });
</script>

<style scoped lang="sass">
.navrh-control-tip
    display: inline-flex
    align-items: center
    gap: 4px
    vertical-align: middle

.navrh-control-tip--block
    display: flex
    width: 100%

    .navrh-control-tip__wrap
        flex: 1
        display: flex

        > *
            flex: 1

.navrh-control-tip__wrap
    cursor: help

.navrh-control-tip__icon
    opacity: .8
    cursor: pointer
    flex-shrink: 0
</style>
